export const visit = (vm, at) => {
at({ "no-no": { "conversationsVisitorUIPageTitleNotifications": { "newMessage": "Ny melding" } } });
};